<div class="center">
    <div id="error-404" style="margin-top:200px;" fxLayout="column" fxLayoutAlign="center center">

        <div class="content" fxLayout="column" fxLayoutAlign="center center">

            <div class="error-code">404</div>

            <div class="message">Sorry but we could not find the page you are looking for</div>

            <a class="back-link" (click)="previous()" href="javascript:void(null)">Go back page</a>

        </div>

    </div>
</div>